const convertNoIndexURL = url => url.replace(/([^/]+)$/, 'noindex-$1');
const noIndexImageTransformer = image =>
  Object.fromEntries(
    Object.entries(image || {}).map(([key, value]) => [key, key === 'blurHash' ? value : convertNoIndexURL(value)]),
  );

export const transformImagesWithNoIndex = ({ data = [], ...rest } = {}) => {
  const transformedData = data.map(item => {
    if (item?.artist?.image) {
      return {
        ...item,
        artist: {
          ...item.artist,
          image: noIndexImageTransformer(item.artist.image),
        },
      };
    }

    if (item?.venue?.logo) {
      return {
        ...item,
        venue: {
          ...item.venue,
          logo: noIndexImageTransformer(item.venue.logo),
        },
      };
    }

    if (item?.organization?.logo) {
      return {
        ...item,
        organization: {
          ...item.organization,
          logo: noIndexImageTransformer(item.organization.logo),
        },
      };
    }

    if (item?.image) {
      return {
        ...item,
        image: noIndexImageTransformer(item.image),
      };
    }

    if (item?.logo) {
      return {
        ...item,
        logo: noIndexImageTransformer(item.logo),
      };
    }

    return item;
  });

  return {
    ...rest,
    data: transformedData,
  };
};

export const transformRepertoireDataIntoRoleGraphData = inputData => {
  if (!inputData) {
    return [];
  }

  // NOTE: Transform each composer's data
  const transformedData = Object.entries(inputData?.data).map(([, composerData]) => {
    const composerInfo = composerData.composer[0];

    // Transform the composer information
    const transformedComposer = {
      firstName: composerInfo.profile.firstName,
      lastName: composerInfo.profile.lastName,
      image: composerInfo.profile.image,
      name: composerInfo.profile.name,
      id: composerInfo.profile.id,
      shortName: composerInfo.profile.shortName,
      headline: composerInfo.profession.name,
      validationStatus: composerInfo.profile.validationStatus,
      slug: composerInfo.profile.slug,
    };

    // Transform the works data
    const transformedWorks = composerData.data.map(workData => {
      const { work } = workData;
      const credits = workData.data.map(roleData => ({
        credit: roleData.workRole?.name || '',
        years: {},
        status: roleData?.status,
        genre: {
          id: work.workType.id,
          name: work.workType.name,
          stagingTypes: [], // This would need to be populated with actual staging data
        },
        isDesireRole: true,
      }));

      return {
        work: {
          id: work.id,
          name: work.name,
          slug: work.slug,
          original_name: work.original_name,
        },
        credits,
      };
    });

    return {
      composer: transformedComposer,
      works: transformedWorks,
    };
  });

  return transformedData;
};
